module.exports = __webpack_public_path__ + "img/love.b6e4b2d4.svg";